export const PEOPLE ='PEOPLE';
export const FETCH_TOKENINSTANCE='FETCH_TOKENINSTANCE';
export const OAUTH_TOKEN = 'OAUTH_TOKEN';
export const FETCH_REVOKEINSTANCE = 'FETCH_REVOKEINSTANCE';

